class BannerStatic {
    // 1. describe and create/initiate our object
    constructor() {
        this.section = document.querySelector('.banner-static');
        if(this.section) {
            this.mobileLogoUrl = this.section.getAttribute("data-mobile-image")
        }
        if (this.section && this.mobileLogoUrl) {
            this.events();
        }
    }

    // 2. events
    events() {
        if(window.innerWidth < 768) {
            this.handleLogoChange(this.section, this.mobileLogoUrl);
        }
    }

    // 3. methods (function, action...)
    handleLogoChange(section, mobileLogo) {
        section.style.backgroundImage = 'url(' + mobileLogo + ')';
    }
}

export default BannerStatic;
